module.exports = __webpack_public_path__ + "static/media/STWire2b.e7637ebd.png";